import { DefaultLogger, SafeShell } from '../../../core';
import { PageAccessCoordinator } from './page-access-coordinator';
import { PageInfoParser } from './page-info-parser';
import type { AutoPageViewOptions } from './types';

/**
 * 创建页面访问采集器（框架无关）。将标准页面信号接入协调器，
 * 最终通过注入的 track 回调统一走 tracker.track(eventName, properties) 出口。
 */
export function createAutoPageView(options: AutoPageViewOptions): PageAccessCoordinator {
  const logger = options.logger ?? new DefaultLogger();
  const safeShell = new SafeShell(logger);
  const parser = new PageInfoParser(safeShell);
  return new PageAccessCoordinator(options, parser, safeShell, logger);
}
